import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/partiesSearch';

const namespace = 'PARTIES_SEARCH';

export const FETCH_SEARCH_CONFIG_START = `${namespace}/FETCH_SEARCH_CONFIG_START`;
export const FETCH_SEARCH_CONFIG_SUCCESS = `${namespace}/FETCH_SEARCH_CONFIG_SUCCESS`;
export const FETCH_SEARCH_CONFIG_ERROR = `${namespace}/FETCH_SEARCH_CONFIG_ERROR`;

export const fetchSearchConfig = makeApiActionCreatorV3(
  api.fetchSearchConfig,
  FETCH_SEARCH_CONFIG_START,
  FETCH_SEARCH_CONFIG_SUCCESS,
  FETCH_SEARCH_CONFIG_ERROR,
);

export const FETCH_SEARCH_RESULTS_CONFIG_START = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_START`;
export const FETCH_SEARCH_RESULTS_CONFIG_SUCCESS = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_SUCCESS`;
export const FETCH_SEARCH_RESULTS_CONFIG_ERROR = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_ERROR`;

export const fetchSearchResultsConfig = makeApiActionCreatorV3(
  api.fetchSearchResultsConfig,
  FETCH_SEARCH_RESULTS_CONFIG_START,
  FETCH_SEARCH_RESULTS_CONFIG_SUCCESS,
  FETCH_SEARCH_RESULTS_CONFIG_ERROR,
);

export const FETCH_SEARCH_CODES_START = `${namespace}/FETCH_SEARCH_CODES_START`;
export const FETCH_SEARCH_CODES_SUCCESS = `${namespace}/FETCH_SEARCH_CODES_SUCCESS`;
export const FETCH_SEARCH_CODES_ERROR = `${namespace}/FETCH_SEARCH_CODES_ERROR`;

export const fetchSearchCodes = makeApiActionCreatorV3(
  api.fetchSearchCodes,
  FETCH_SEARCH_CODES_START,
  FETCH_SEARCH_CODES_SUCCESS,
  FETCH_SEARCH_CODES_ERROR,
);

export const SEARCH_START = `${namespace}/SEARCH_START`;
export const SEARCH_SUCCESS = `${namespace}/SEARCH_SUCCESS`;
export const SEARCH_ERROR = `${namespace}/SEARCH_ERROR`;

export const search = makeApiActionCreatorV3(
  api.search,
  SEARCH_START,
  SEARCH_SUCCESS,
  SEARCH_ERROR,
);

export const FETCH_CODEFILE_CASE_STATE_START = `${namespace}/FETCH_CODEFILE_CASE_STATE_START`;
export const FETCH_CODEFILE_CASE_STATE_SUCCESS = `${namespace}/FETCH_CODEFILE_CASE_STATE_SUCCESS`;
export const FETCH_CODEFILE_CASE_STATE_ERROR = `${namespace}/FETCH_CODEFILE_CASE_STATE_ERROR`;

export const fetchCodefileCaseState = makeApiActionCreatorV3(
  api.fetchCodefileCaseState,
  FETCH_CODEFILE_CASE_STATE_START,
  FETCH_CODEFILE_CASE_STATE_SUCCESS,
  FETCH_CODEFILE_CASE_STATE_ERROR,
);

export const FETCH_CODEFILE_CASE_STATUS_START = `${namespace}/FETCH_CODEFILE_CASE_STATUS_START`;
export const FETCH_CODEFILE_CASE_STATUS_SUCCESS = `${namespace}/FETCH_CODEFILE_CASE_STATUS_SUCCESS`;
export const FETCH_CODEFILE_CASE_STATUS_ERROR = `${namespace}/FETCH_CODEFILE_CASE_STATUS_ERROR`;

export const fetchCodefileCaseStatus = makeApiActionCreatorV3(
  api.fetchCodefileCaseStatus,
  FETCH_CODEFILE_CASE_STATUS_START,
  FETCH_CODEFILE_CASE_STATUS_SUCCESS,
  FETCH_CODEFILE_CASE_STATUS_ERROR,
);

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const CHANGE_SORT_MODEL = `${namespace}/CHANGE_SORT_MODEL`;

export const changeSortModel = model => ({
  type: CHANGE_SORT_MODEL,
  payload: model,
});

export const CHANGE_FILTER_MODEL = `${namespace}/CHANGE_FILTER_MODEL`;

export const changeFilterModel = model => ({
  type: CHANGE_FILTER_MODEL,
  payload: model,
});
